// e.g. you can render richtext or simple text based on this
export const hasStringField = (obj: any) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && typeof obj[key] === "string") {
      return true;
    }
  }
  return false;
};
